import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CurrentOrganizationProviderService {
  private data: any = {};

  constructor() {}

  setCurrentOrg(d: any) {
    this.data = d;
  }

  get getCurrentOrg() {
    return this.data;
  }

  clearCurrentOrg() {
    this.data = {};
  }
}

// For backwards compatibility - both as class alias and as provider token
export { CurrentOrganizationProviderService as currentOrganizationProvider };